import { FC } from 'react';
import { Badge } from '@/components/ui/badge';
import { ConfigurationType, ConfigurationTypeEnum } from '@libs/schemas';

interface RuleTypeBadgeProps {
  type: ConfigurationType;
}

export const RuleTypeBadge: FC<RuleTypeBadgeProps> = ({ type }) => {
  const getDisplayName = (type: ConfigurationType) => {
    switch (type) {
      case ConfigurationTypeEnum.CONTAINER_MATERIAL_MATRIX:
        return 'Single Material';
      case ConfigurationTypeEnum.CONTAINER_PERIOD_PRICING:
        return 'Flat Rate';
      case ConfigurationTypeEnum.TONNAGE_PRICING:
        return 'Tonnage Pricing';
      case ConfigurationTypeEnum.AUTO_DISCOUNT:
        return 'Auto Discount';
      case ConfigurationTypeEnum.DISCOUNT:
        return 'Discount';
      case ConfigurationTypeEnum.PAY_AS_YOU_GO_PRICING:
        return 'Pay As You Go';
      default:
        return String(type).replace(/_/g, ' ');
    }
  };

  return (
    <Badge variant="outline" className="bg-gray-50 text-gray-700 hover:bg-gray-100 border-gray-200">
      {getDisplayName(type)}
    </Badge>
  );
};
